import { SET_ACCOUNT_ORGANIZATION_ID } from 'actions';

export function setAccountOrganizationId(organizationId: string) {
  return { organizationId, type: SET_ACCOUNT_ORGANIZATION_ID };
}
